// Country list for club address selectors. ISO-3166 alpha-2 codes.
// Names are in Serbian since that's the primary admin locale; we surface
// translated names via i18n where shown to end-users.
export interface CountryOption {
  code: string;
  name: string;
}

export const COUNTRIES: CountryOption[] = [
  { code: "RS", name: "Srbija" },
  { code: "BA", name: "Bosna i Hercegovina" },
  { code: "ME", name: "Crna Gora" },
  { code: "HR", name: "Hrvatska" },
  { code: "MK", name: "Severna Makedonija" },
  { code: "SI", name: "Slovenija" },
  { code: "AL", name: "Albanija" },
  { code: "BG", name: "Bugarska" },
  { code: "RO", name: "Rumunija" },
  { code: "HU", name: "Mađarska" },
  { code: "AT", name: "Austrija" },
  { code: "DE", name: "Nemačka" },
  { code: "CH", name: "Švajcarska" },
  { code: "FR", name: "Francuska" },
  { code: "IT", name: "Italija" },
  { code: "ES", name: "Španija" },
  { code: "NL", name: "Holandija" },
  { code: "GB", name: "Velika Britanija" },
  { code: "US", name: "SAD" },
  { code: "RU", name: "Rusija" },
  { code: "TR", name: "Turska" },
];

export const DEFAULT_COUNTRY = "RS";

export function countryName(code: string | null | undefined): string {
  if (!code) return "";
  return COUNTRIES.find((c) => c.code === code)?.name ?? code;
}
